import { menu } from "./menu";
/* 产品数据 */
export const menuselect = () => {
  let arr = menu[0].children.map((item) => {
    return {
      name: item.name,
      url: item.children[0].route,
    };
  });
  return arr;
};
/* 解决方案数据 */
export const menuselect_solution = () => {
  let arr = menu[1].children.map((item) => {
    return {
      name: item.name,
      url: item.route,
    };
  });
  return arr;
};
export const getrouteparams = () => {
  let routeQuery = sessionStorage.getItem("routeQuery");
  return routeQuery;
};
